import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Form, Button, Image } from 'react-bootstrap';
import './EditProfile.css';
import NeighbourSidebar from "../../NeighbourSidebar";
import Header from "../../NeighbourHeaderAfterLogin";
import Footer from "../../FooterAfterLogin";
import loader from '../../../assests/loader.gif';
import API from '../../../Utils/Api';
import { Link, useNavigate } from 'react-router-dom';
import {validateprofile} from '../../../Utils/validate';
import { gettoastwarning,gettoastsuccess } from '../../../Utils/Common';

const EditProfile = () => {

    const navigate = useNavigate();

    const [loading,setLoading] = useState(true);
    
    const [errors,setErrors] = useState({});
    const [inputs,setInputs] = useState({first_name:'',last_name:'',email:'',contact_number:''});


    useEffect(() => {
        document.title = `Edit Profile | Local Bells`;
        document.getElementById('bodywrap').className = 'needitprof';

        /* Start get profile */
            API.get('get_user_detail')
                .then(response => {
                    setLoading(false);
                if(response.data.status === false){
                    
                }else{
                  setInputs({
                    first_name:response.data.data.first_name,
                    last_name:response.data.data.last_name,
                    email:response.data.data.email,
                    contact_number:response.data.data.contact_number,
                  });
                }                  
            }).catch(error => {
                setLoading(false); 
            });  
        /* End get profile */

    }, []);

    // State to toggle sidebar visibility
    const [isSidebarVisible, setIsSidebarVisible] = useState(false);

    // Function to toggle sidebar visibility
    const toggleSidebar = () => {
        setIsSidebarVisible((prev) => !prev);
    };

    const handleSubmit = (e) => {
    e.preventDefault();
    const validationErrors = validateprofile(inputs);
     const noErrors = Object.keys(validationErrors).length === 0;
        setErrors({});
        setErrors(validationErrors);
        
        if(noErrors){
                setLoading(true);
            
            let formData = new FormData(); 
            Object.keys(inputs).forEach((key) => {
            formData.append(key, inputs[key]);
        });
            API.post('update_user_detail', formData)
              .then(response => {
              if(response.data.status === false){
                //setError(response.data.message);
                setLoading(false); 
                gettoastwarning(response.data.message,'');
              }else{
                 setLoading(false);
                 var is_profile_verify2=1;
                    localStorage.setItem("is_profile_verify", is_profile_verify2);
                 gettoastsuccess(response.data.message,'/neighbour/view-profile');
              }                  
            }).catch(error => {
               setLoading(false);
               gettoastwarning("Something went wrong. Please try again later.",'');
                //setError("Something went wrong. Please try again later.");
            });
        }
    //navigate('/neighbour/login');
  };
/* Start Value set */
const handleInputChangeMo = (event) => {
  event.persist();
  const { name, value } = event.target;

  // Allow only numbers (0–9)
  const regex = /^[0-9]*$/;

  if (regex.test(value)) {
    setInputs(inputs => ({ ...inputs, [name]: value }));
  }      
}
const handleInputChangeSpe = (event) => {
  event.persist();
  const { name, value } = event.target;

  // Allow only letters, numbers, spaces, and basic punctuation if needed
  const regex = /^[a-zA-Z0-9\s]*$/;

  if (regex.test(value)) {
    setInputs(inputs => ({ ...inputs, [name]: value }));
  }    
}
/* End Value set */



    return (
        <>
            <section className="main-cont-box">
                <Container>
                    <Row>
                        <NeighbourSidebar isVisible={isSidebarVisible} setIsVisible={setIsSidebarVisible} />
                        <Col md={12} lg={9} xl={9} xxl={10} className='main-cont-box-right'>
                            <Header toggleSidebar={toggleSidebar} />  
                            <div className='nei-cont'>
                                <Row>
                                    <Col md={8} lg={8} xl={7} xxl={5}>
                                        <div className='white-box edpf-box'>
                                            <div className="d-flex align-items-start justify-content-between gap-3">                                               
                                                <h3 className='mb-3'>Edit Your Profile</h3>
                                                <Link to="#" onClick={() => navigate(-1)} className='cross-up'>
                                                    <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/cross.webp'} className="img-fluid crosy" alt="wp" />
                                                </Link>
                                            </div>                                            
                                            <Form onSubmit={handleSubmit}>
                                                <Row>
                                                    <Col md={6}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label className=''>First Name</Form.Label>
                                                            <Form.Control type="text" placeholder="First Name" name="first_name" onChange={handleInputChangeSpe} value={inputs.first_name} />
                                                            {errors.first_name && (<p className="text-danger">{errors.first_name}</p>)}
                                                        </Form.Group>                                                    
                                                    </Col>
                                                    <Col md={6}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label className=''>Last Name</Form.Label>
                                                            <Form.Control type="text" placeholder="Last Name" name="last_name" onChange={handleInputChangeSpe} value={inputs.last_name} />
                                                            {errors.last_name && (<p className="text-danger">{errors.last_name}</p>)}
                                                        </Form.Group>                                                    
                                                    </Col>
                                                </Row>

                                                <Form.Group className="mb-3">
                                                    <Form.Label className=''>Your Email</Form.Label>
                                                    <Form.Control type="email" placeholder="Your Email" value={inputs.email}  disabled/>
                                                </Form.Group>

                                                <Form.Group className="mb-3">
                                                    <Form.Label className=''>Phone number</Form.Label>
                                                    <Form.Control type="text" placeholder="Contact number" name="contact_number" onChange={handleInputChangeMo} value={inputs.contact_number} maxLength={15} />
                                                    {errors.contact_number && (<p className="text-danger">{errors.contact_number}</p>)}
                                                </Form.Group>

                                                {/*<Form.Group className="mb-3">
                                                    <Form.Label className='d-none'>Pin code</Form.Label>
                                                    <Form.Control type="text" placeholder="Pin code" />
                                                </Form.Group>                                          

                                                <Row>
                                                    <Col md={4}>
                                                        <Form.Select aria-label="Default select example">
                                                            <option>State</option>
                                                            <option value="nashik">Maharastra</option>
                                                            <option value="ratnagiri">Gujarat</option>
                                                            <option value="nagpur">Karnataka</option>
                                                        </Form.Select>	                                                   
                                                    </Col>
                                                    <Col md={4}>
                                                        <Form.Select aria-label="Default select example">
                                                            <option>District</option>
                                                            <option value="nashik">Nashik</option>
                                                            <option value="ratnagiri">Ratnagiri</option>
                                                            <option value="nagpur">Nagpur</option>
                                                            <option value="ahmedabad">Ahmedabad</option>
                                                            <option value="surat">Surat</option>
                                                            <option value="gandhinagar">Gandhinagar</option>
                                                            <option value="bengaluru">Bengaluru</option>
                                                            <option value="mysuru">Mysuru</option>
                                                            <option value="udupi">Udupi</option>
                                                        </Form.Select>	                                                     
                                                    </Col>
                                                    <Col md={4}>
                                                        <Form.Select aria-label="Default select example">
                                                            <option>Town</option>
                                                            <option value="belur">Belur</option>
                                                            <option value="aldur">Aldur</option>
                                                            <option value="hornadu">Hornadu</option>
                                                            <option value="dapoli">Dapoli</option>
                                                            <option value="khed">Khed</option>
                                                            <option value="bhor">Bhor</option>												
                                                        </Form.Select>	                                                    
                                                    </Col>
                                                </Row>*/}                                                                                                              
                                                <Button type="submit" className='blue-btn'>Save profile</Button>
                                            </Form>                                             
                                        </div>
                                    </Col>
                                </Row>
                                <div className='footer-main footer'>
                                    <Footer />                                
                                </div>                                    
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
            {loading && (
               <div className="loadingClass">
                <img src={loader} alt="loader"/>
              </div>
               )}
        </>
    )
}

export default EditProfile;


